
import React, { useState } from 'react';
import { SessionRegistration } from './SessionRegistration'; // Import your popup component

export const UpcomingSession = ({ fbpAllocation, sessionData, fetchSessions }) => {
    const [showPopup, setShowPopup] = useState(false);
    const [selectedSession, setSelectedSession] = useState(null);
    const [isRegistered, setIsRegistered] = useState(false); // Add state for isRegistered
    const [selectedSlotStatus, setSelectedSlotStatus] = useState(''); // State to hold the selected slot's status

    // Function to get the current quarter as an integer (1-4)
    const getCurrentQuarter = () => {
        const month = new Date().getMonth(); // 0-11 (Jan-Dec)
        if (month >= 6 && month <= 8) return "2"; // July to September -> Quarter 3
        if (month >= 3 && month <= 5) return "1"; // April to June -> Quarter 2
        if (month >= 0 && month <= 2) return "4"; // January to March -> Quarter 1
        return "3"; // October to December -> Quarter 4
    };

    // Calculate the number of sessions registered
    const registeredCount = Array.isArray(sessionData)
        ? sessionData.reduce((count, session) => {
            return count + session.slots.filter(slot => slot.status === "Register" || slot.status === "Reschedule").length;
        }, 0)
        : 0;

    const currentQuarter = getCurrentQuarter();

    const handleRegistration = (session) => {
        setSelectedSession(session);
        const registeredSlot = session.slots.find(slot => slot.status === "Register" || slot.status === "Reschedule");
        setIsRegistered(!!registeredSlot); // Set isRegistered based on whether a registered slot exists
        setSelectedSlotStatus(registeredSlot ? 'Register' : ''); // Set the status of the registered slot
        setShowPopup(true);
    };

    const parseDaysLeft = (daysLeft) => {
        if (daysLeft === "Past") return -1;
        if (typeof daysLeft === "string" && daysLeft.includes("days")) {
            return parseInt(daysLeft.split(" ")[0], 10);
        }
        if (typeof daysLeft === "string" && daysLeft.includes("month")) {
            return 30; // Approximate a month as 30 days
        }
        return 999; // Future date
    };

    return (
        <div>
            {!Array.isArray(sessionData) || sessionData.length === 0 ? (
                <div className="row justify-content-center d-flex">
                    <div className="d-flex flex-column align-items-center justify-content-center container-height">
                        <img className="empty-img-width mb-4" src="Images/table-empty-state.svg" alt="empty-state" />
                        <p className="font-14 medium-text grey-text mb-1">Currently, No session available to display</p>
                    </div>
                </div>
            ) : (
                <div className="row">
                    {sessionData.map((session, index) => {
                        // Check if the session is registered by the user
                        const registeredSlot = session.slots.find(slot => slot.status === "Register" || slot.status === "Reschedule");
                        const isRegistered = !!registeredSlot;

                        // Calculate available sessions by counting only active slots
                        const activeSlotsCount = session.slots.filter(slot => slot.is_active).length;

                        // All slots are past
                        const allSlotsPast = session.slots.every(slot => parseDaysLeft(slot.days_left) < 0);

                        // Registered slot is past
                        const registeredSlotPast = isRegistered && parseDaysLeft(registeredSlot.days_left) < 0;

                        // Registered slot is less than 7 days left
                        // const registeredSlotImminent = isRegistered && parseDaysLeft(registeredSlot.days_left) >= 0 && parseDaysLeft(registeredSlot.days_left) < 7;

                        // Card should be disabled if:
                        // 1. Registered slot is past (show completed)
                        // 2. User not registered and all slots are past (show completed)
                        // 3. Registered slot is imminent (<7 days) (disable card)
                        let isDisabled = false;
                        let showCompletedBadge = false;

                        if (registeredSlotPast) {
                            isDisabled = true;
                            showCompletedBadge = true;
                        } else if (!isRegistered && allSlotsPast) {
                            isDisabled = true;
                            showCompletedBadge = true;
                            // } else if (registeredSlotImminent) {
                            //     isDisabled = true;
                        } else if ((registeredCount >= fbpAllocation && !isRegistered)) {
                            isDisabled = true;
                        }

                        // For badges
                        const hasRegistered = isRegistered && registeredSlot.status === "Register";
                        const hasRescheduled = isRegistered && registeredSlot.status === "Reschedule";

                        return (
                            <div className="col-md-3 mb-4" key={index}>
                                <div className={`session-card d-flex flex-column justify-content-between align-items-start bg-white p-4 position-relative ${isDisabled ? 'disabled' : ''}`}>
                                    <div className="d-flex flex-column justify-content-start">
                                        <p className="font-22 semibold-text">{session.session_name}</p>
                                        <p className="font-18 medium-text grey-v2">Quarter {session.quarter}</p>
                                        <div className="available-session-badge d-flex justify-content-center align-items-center px-3 py-2">
                                            <img src="Images/calendar-icon.svg" alt="calendar-icon" className="me-2" />
                                            <span className="font-14 medium-text">Available Sessions:<span className="ms-2">{activeSlotsCount}</span></span>
                                        </div>
                                    </div>
                                    {/* Button for registration or editing */}
                                    {!showCompletedBadge && (
                                        <button
                                            className={`btn hive-btn-outline mt-5 align-self-end ${isDisabled ? 'disabled' : ''}`}
                                            onClick={() => !isDisabled && handleRegistration(session)}
                                        >
                                            {hasRegistered || hasRescheduled ? 'Edit Registration' : 'Register Now'}
                                        </button>
                                    )}
                                    {/* Status badges */}
                                    {hasRegistered && !showCompletedBadge && (
                                        <span className="font-12 medium-text status-label-success visible">Registered</span>
                                    )}
                                    {hasRescheduled && !showCompletedBadge && (
                                        <span className="font-12 medium-text status-label-success visible">Rescheduled</span>
                                    )}
                                    {showCompletedBadge && (
                                        <span className="font-12 medium-text status-label-success visible">Completed</span>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            {/* Popup for Session Registration */}
            {showPopup && (
                <SessionRegistration
                    session={selectedSession}
                    onClose={() => setShowPopup(false)}
                    status={selectedSlotStatus}
                    fetchSessions={fetchSessions}
                />
            )}
        </div>
    );
};